import { CV_TEMPLATE_IDS } from "@/lib/cv-model";

// Shared, data-only spec for the Documents Input/Output action cards.
// Single source of truth so every surface renders the same list: the
// Documents page (the user's document store) and the profile ServiceMenu,
// plus any future place that reuses these flows. The action handlers live
// in the useServiceActions hook - both surfaces consume it and run the
// action in-place via dialogs, no navigation. Internal keys keep the legacy
// `service.*` namespace; only the user-facing label became "Documents".
export type ServiceAction = "power" | "skills" | "cv" | "export" | "linkedin" | "cv-extract";

export type ServiceCardSpec = {
  icon: string;
  titleId: string;
  descId: string;
  tags: string;
  action?: ServiceAction;
  comingSoon?: boolean;
};

export const SERVICE_INPUTS: readonly ServiceCardSpec[] = [
  { icon: "▽", titleId: "service.page.cardPowerTitle", descId: "service.page.cardPowerDesc", tags: "Powered by smycles AI", action: "power" },
  { icon: "▥", titleId: "service.page.cardHardskillTitle", descId: "service.page.cardHardskillDesc", tags: "Powered by smycles AI", action: "skills" },
  { icon: "▤", titleId: "service.page.cardCvExtractorTitle", descId: "service.page.cardCvExtractorDesc", tags: "PDF · DOCX · OCR", action: "cv-extract" },
  { icon: "in", titleId: "service.page.cardLinkedinTitle", descId: "service.page.cardLinkedinDesc", tags: "LinkedIn · OAuth", action: "linkedin" },
];

export const SERVICE_OUTPUTS: readonly ServiceCardSpec[] = [
  { icon: "▣", titleId: "service.page.cardCvGeneratorTitle", descId: "service.page.cardCvGeneratorDesc", tags: `${CV_TEMPLATE_IDS.length} TEMPLATES · PDF`, action: "cv" },
  { icon: "⤓", titleId: "service.page.cardDatatransferTitle", descId: "service.page.cardDatatransferDesc", tags: "DSGVO · JSON", action: "export" },
];
